
import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslateEn } from "@/languages/translate_en";
import { TranslateMalay } from "@/languages/translate_malay";
import SidHeader from "../../sidbarMenu/sidHeader.vue";

@Component({
  components: {
    SidHeader: SidHeader,
  },
})
export default class SideBar extends Vue {
  @Prop({ default: "" }) routePath!: string;
  @Prop({ default: false }) showSidebar!: boolean;
  @Prop({ default: true }) showButtonMenu!: boolean;
  jobseekerMenu = [];
  selectedLanguage: string = "";
  jobseekermenuLang: any;

  
  async created() {
    if (
      localStorage.getItem("selectedlanguage") != undefined &&
      localStorage.getItem("selectedlanguage") != null
    ) {
      this.selectedLanguage = localStorage.getItem("selectedlanguage");
    } else {
      localStorage.setItem("selectedlanguage", "en");
      this.selectedLanguage = "en";
    }
    if (this.selectedLanguage == "en") {
      this.jobseekermenuLang = TranslateEn.jobSeekerMenu;
    } else {
      this.jobseekermenuLang = TranslateMalay.jobSeekerMenu;
    }

    this.jobseekerMenu = [
      {
        header: true,
        component: SidHeader,
        props: {
          onToggleSidebar: this.handleMenuClick,
        },
        hiddenOnCollapse: true
      },
      {
        title: this.jobseekermenuLang.home,
        icon: 'fas fa-home',
        href: '/individualDashboard'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/individualDashboard");
        // },
      },
      {
        title: this.jobseekermenuLang.courses,
        icon: 'fas fa-chalkboard-teacher',
        href: '/courseSearch'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/courseSearch");
        // },
      },
      {
        title: this.jobseekermenuLang.satelliteEvents,
        href: "/satelliteEventSearch",
        icon: 'fas fa-folder',
      },
      // {
      //   title: this.jobseekermenuLang.archive_courses,
      //   icon: 'fas fa-folder',
      //   href: '/archivedCourseSearch'
      //   // command: (event) => {
      //   //   localStorage.removeItem("searchJobSkills");
      //   //   this.$router.push("/courseSearch");
      //   // },
      // },
      {
        title: this.jobseekermenuLang.appliedCourses,
        href: "/courseHistoryForIndividual",
        icon: 'fas fa-search',
      },
      {
        title: this.jobseekermenuLang.myProfiles,
        icon: 'fas fa-users',
        href: '/profile'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/profile");
        // },
      }
    ]

  }

  handleMenuClick() {
    if (window.innerWidth <= 1024) {
    this.$emit("toggle-sidebar");
    }
  }

}
